import { api, ApiRoutes } from './ApiService'
import { Color } from '../types/Color'

export const ColorService = {
    async getAllColors(): Promise<Color[]> {
        try {
            const response = await api.get(ApiRoutes.COLORS)
            return response.data?.data?.colors || []
        } catch (error) {
            console.error('Failed to fetch colors:', error)
            return []
        }
    },

    async createColor(name: string, color: string): Promise<{ id: number } | null> {
        try {
            const response = await api.post(ApiRoutes.COLORS, undefined, {
                name: name.toLowerCase().trim(),
                color: color.trim(),
            })
            return response.data?.data || null
        } catch (error) {
            console.error('Failed to create color:', error)
            throw error
        }
    },

    async deleteColor(id: number): Promise<void> {
        try {
            await api.delete(ApiRoutes.COLORS, id)
        } catch (error) {
            console.error('Failed to delete color:', error)
            throw error
        }
    },
}
